import {
  OuiBoxComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { PageComponent } from '../../components/page/page';
import { SelectComponent } from '../../components/select/select.component';
import { EcommerceService } from '../../services/ecommerce/ecommerce.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-currency-conversion',
  standalone: true,
  imports: [
    OuiBoxComponent,
    OuiStackComponent,
    OuiTextComponent,
    DownloadButtonComponent,
    PageComponent,
    ReactiveFormsModule,
    SelectComponent,
  ],
  templateUrl: './currency-conversion.component.html',
})
export class CurrencyConversionPage extends BasePageComponent {
  readonly ecommerceService = inject(EcommerceService);

  readonly sourceCurrencyCodes = toSignal(
    this.ecommerceService.getSourceCurrencyCodes(),
    { initialValue: [] },
  );

  readonly sourceCurrencyOptions = computed(() =>
    this.sourceCurrencyCodes().map((code) => ({
      label: code,
      value: code,
    })),
  );

  readonly downloadForm = new FormGroup({
    sourceCurrency: new FormControl<string | null>(null, {
      validators: Validators.required,
    }),
  });

  readonly selectedSourceCurrency = toSignal(
    this.downloadForm.controls.sourceCurrency.valueChanges,
    { initialValue: null },
  );

  readonly currencyConversionFileName = computed(() =>
    ['ATB', 'CurrencyConversion', this.selectedSourceCurrency(), new Date().toISOString().slice(0, 10)]
      .filter(Boolean)
      .join('_'),
  );
}
